import * as React from "react";
import { HiddenContent } from "./InvoiceStyles";
import { translations } from "../../translations/common";

interface Props {
  pdfUrl: () => Promise<string>;
  close: () => void;
}

const InvoicePrintComponent: React.FC<Props> = ({ pdfUrl, close }) => {
  const [invoiceUrl, setInvoiceUrl] = React.useState<string | null>(null);

  const print = () => {
    const iframe = document.getElementById("printFrame") as HTMLIFrameElement;
    const iframeWindow = iframe.contentWindow;
    if (iframeWindow) {
      iframeWindow.focus();
      iframeWindow.print();
    } else {
      close();
    }
  };

  React.useEffect(() => {
    pdfUrl().then(setInvoiceUrl);
  }, [pdfUrl]);

  return (
    <HiddenContent>
      {invoiceUrl && (
        <iframe
          id="printFrame"
          title="sąskaita"
          src={invoiceUrl}
          onLoad={print}
          width="700"
          height="500"
        >
          <p>{translations.invoice.modalView.browserNotSupported}</p>
        </iframe>
      )}
    </HiddenContent>
  );
};

export default InvoicePrintComponent;
